import { usePlatformUpdate } from '@reapitform/hooks'
import { IDefaultEmergencyContact, TEmergencyContactSchema } from '../../types'

export const useDefaultEmergencyContactUpdate = () => {
  const path: string = '/api/Organization/DefaultRepairer/'

  const [updateEmergencyContact, isLoading, returnData, isSuccess, isError] = usePlatformUpdate<
    TEmergencyContactSchema,
    IDefaultEmergencyContact
  >({
    path: path,
    method: 'PUT',
    headers: {},
    errorMessage: 'Failed to update the repairer data',
    successMessage: 'Repairer data successfully updated',
  })

  return { updateEmergencyContact, returnData, isLoading, isSuccess, isError }
}
